import React from 'react'

import Loader from '../components/loader'

const LoadingPage: React.FunctionComponent = () => {
  return <Loader size="75px" />
}

export default LoadingPage
